module.exports = __webpack_public_path__ + "static/media/28.9cc0cf6b.mp3";